var React = require('react');

function LinkedinInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"post-linkedin"},React.createElement("path",{"id":"Path_5","data-name":"Path 5","d":"M36,0H4A4.012,4.012,0,0,0,0,4V36a4.012,4.012,0,0,0,4,4H36a4.012,4.012,0,0,0,4-4V4A4.012,4.012,0,0,0,36,0ZM12,34H6V16h6ZM9,12.6A3.6,3.6,0,1,1,12.6,9,3.585,3.585,0,0,1,9,12.6ZM34,34H28V23.4a3,3,0,0,0-6,0V34H16V16h6v2.4a6.46,6.46,0,0,1,5-2.8,7.086,7.086,0,0,1,7,7Z","fill":"#707070"})));
}

LinkedinInline.defaultProps = {"id":"linkedin","width":"40","height":"40","viewBox":"0 0 40 40"};

module.exports = LinkedinInline;

LinkedinInline.default = LinkedinInline;
